export default {
  'h_one': '链浏览器',
  'tit_one': '测试网',
  'tit_two': '主网',
  'HyperchainSpaceHeight': '超块高度',
  'SpaceHeight':'超块高度',
  'Nodes': '节点数',
  'NodeMap': '节点地图',
  'Blockchains': '子链数',
  'Concurrency': '并发峰值',
  'HBlock': '超块号',
  'LChains': '子链数',
  'Search': '搜索',
  'Tips': 'Example: Input [ 123,1,2 ] for Block ID，input Transaction hash as Transaction ID.',
  'Time': '时间戳',
  'Blocks': '区块数',
  'Chains': '区块链数',
  'Next': '后一个',
  'Previous': '前一个',
  'HyperBlock': '超块号',
  'LocalBlockId': '子块号',
  'Localchains': '子链数',
  'BlockSize': '块大小',
  'BlockVersion': '块版本',
  'BlockHash': '块哈希',
  'PreviousBlockHash': '前驱区块哈希',
  'Consensus': '共识算法',
  'Difficulty': '难度',
  'Height': '高度',
  'Size': '块大小',
  'Ver': '版本',
  'Payload': '区块负载',
  'Localchain': '子链号',
  'LocalBlock': '子链区块号',
  'PreviousLocalBlock': '前驱区块号',
  'PreviousLocalBlockHash': '前驱区块哈希',
  'HyperblockHash': '超块哈希',
  'RAW': '区块负载原始格式',
  'PayloadHash': '负载哈希',
  'PayloadSize': '负载大小',
  'More': '更多',
  'Fewer': '收起',
  'Help': '帮助',
  'HyperBlockList': '超块列表',
  'LocalChainList': '子链列表',
  'LocalBlockList': '子链区块列表',
  'LocalchainType': '链类型',
  'DApp': '分布式应用',
  'HyperBlockMsg': '超块信息',
  'LocalChainMsg': '子链信息',
  'LocalBlockMsg': '子链区块信息',
  'Top': '回到顶部',
  'mainnet_default': '暂未开放，敬请期待',
  'PreviousHyperBlock_hash': '前驱超块哈希',
  'tx':'交易信息',
  'AppType': '应用类型',
  'T_token': '通证',
  'T_coin': '货币',
  'T_default': '通用',
  'Apps':'应用数',
  'AppName':'应用名称',
  'PayloadRaw': 'Payload原始数据',
  'PayloadParsed': 'Payload解析后的数据',
  'P_default': '无法识别的数据格式，需要数据解析器',
  'SearchbyBlockIDTransactionID': 'Search by Block ID/Transaction ID/Address',
  'TxView': {
    'TxDetail': '交易详情',
    From: '转出方',    
    Title: '转账详情',
    Contract: '合约地址',
    TXID: '交易哈希',
    From: '转出方',
    Sender: '发送人',
    TxAmount: '交易数量',    
    Amount: '数量',
    State: '转账状态',
    Pending: '处理中',
    Failed: '失败',
    Confirmed: '已确认',
    Token: '通证代号',
    Time: '时间',
    Receivers: '接收方',
    TokenName: '通证名称',
    NFTName: 'NFT名称',
    TokenLogo: '通证标识',
    BlockNo: '区块号',
    Data: '数据',    
    Gas: '费用',    
    Copied: '复制成功',
    Sign: '交易签名',
    Mature: '成熟度'
  },
}